import { render, staticRenderFns } from "./modify-bankcard.vue?vue&type=template&id=67634000&scoped=true&"
import script from "./modify-bankcard.vue?vue&type=script&lang=js&"
export * from "./modify-bankcard.vue?vue&type=script&lang=js&"
import style0 from "./modify-bankcard.vue?vue&type=style&index=0&id=67634000&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67634000",
  null
  
)

export default component.exports